/* 🤖 this file was generated by svg-to-ts */
export const siriusTarget: {
  name: 'target';
  data: string;
} = {
  name: 'target',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M5.692 4.525a9.769 9.769 0 0 1 12.654.068L20.47 2.47a.75.75 0 1 1 1.06 1.06L18.9 6.16l-.005.006-.003.002-3.178 3.18c-.002 0-.003.002-.005.004l-.006.005-3.173 3.173a.75.75 0 1 1-1.06-1.06l2.593-2.593a3.74 3.74 0 1 0 1.679 2.912.75.75 0 1 1 1.497-.085 5.241 5.241 0 1 1-2.1-3.904l2.143-2.142a8.269 8.269 0 1 0 2.16 2.784.75.75 0 0 1 1.354-.646 9.77 9.77 0 1 1-15.104-3.27Z" fill="currentColor"/></svg>`
};
